/**
 * billing-constants.js
 */

  // subscription types
export const SubscriptionType = {
  TRIAL: 1,
  MONTHLY: 2,
  YEARLY: 3
};

export const SubscriptionTypeName = {
  [SubscriptionType.TRIAL]: 'Trial',
  [SubscriptionType.MONTHLY]: 'Monthly',
  [SubscriptionType.YEARLY]: 'Annual',
}

// subscription payment types
export const PaymentType = {
  AUTOMATIC: 1,
  REMITTANCE: 2
};

export const PaymentTypeName = {
  [PaymentType.AUTOMATIC]: 'Credit Card (Automatic)',
  [PaymentType.REMITTANCE]: 'Invoice (Remittance)',
}

// subscription status
export const SubscriptionStatus = {
  ACTIVE: 1, // subscription is active
  OVERDUE: 2, // invoice sub is in overdue range / cc sub is in dunning state
  CANCELED: 3, // trial ended / invoice sub is beyond overdue / cc sub failed dunning / user canceled
};

// subscription prices
export const SubscriptionPrice = {
  MONTHLY: 14,
  YEARLY: 140
};

export const unpaidDaysLimit = 30;